const device = [
    {
        path: '/device/manage',
        name: 'deviceManage',
        component: () => import('@/view/device/manage'),
    },
    {
        path: '/device/log',
        name: 'deviceLog',
        component: () => import('@/view/device/log'),
    },
]
export default device